import React from 'react';

// P&L REALIZADO por dia (spot, FIFO): pareia compra→venda e mostra o lucro FECHADO de cada dia em
// USDT e %. Complementa o gráfico mensal acima (que é fluxo de caixa vendas−compras, não lucro real).
// Ver utils/realizedProfit + backend getDailyRealizedReport.
// Os dados vêm do container (Reports.js), a mesma fonte da aba "Rentabilidade diária" do gráfico.
function DailyRealizedCard({ quote, data = { series: [], totalRealized: 0, totalPct: 0 }, error = '' }) {

    const cls = v => (v > 0 ? 'text-success' : v < 0 ? 'text-danger' : 'text-muted');
    const fmt = v => `${v > 0 ? '+' : ''}${Number(v).toFixed(2)}`;
    const series = (data && data.series) ? [...data.series].reverse() : []; // mais recente no topo
    const maxAbsPct = series.reduce((m, d) => Math.max(m, Math.abs(d.pct)), 0) || 1; // barra ∝ retorno (%)

    return (
        <div className="card mb-4">
            <div className="card-header d-flex justify-content-between align-items-center">
                <span className="fw-bold">Lucro realizado por dia <small className="text-muted">(últimos 30 dias, spot)</small></span>
                <span className={`fw-bold ${cls(data.totalRealized)}`}>
                    Total: {fmt(data.totalRealized)} {quote} · retorno {fmt(data.totalPct)}%
                    {data.totalTrades != null && <span className="text-muted"> · {data.totalTrades} trades</span>}
                </span>
            </div>
            <div className="card-body p-0">
                {error && <div className="text-muted small p-3">{error}</div>}
                {!error && series.length === 0 && (
                    <div className="text-muted small p-3">Sem trades fechados (compra→venda) no período — o lucro só aparece quando uma posição é vendida.</div>
                )}
                {series.length > 0 && (
                    <div className="table-responsive" style={{ maxHeight: 360 }}>
                        <table className="table table-sm table-hover mb-0 align-middle">
                            <thead>
                                <tr>
                                    <th className="ps-3" rowSpan={2}>Dia</th>
                                    <th className="text-center" rowSpan={2} title="Quantidade de trades fechados (vendas que realizaram lucro/prejuízo) no dia">Trades</th>
                                    <th className="text-end" rowSpan={2} title="Dinheiro (lucro/prejuízo) realizado no dia">Realizado ({quote})</th>
                                    <th className="text-center border-start" colSpan={2} title="Retorno sobre o capital que fechou no dia (a qualidade do trade) — NÃO é % do patrimônio. Um trade pequeno pode ter % alto com pouco dinheiro.">Retorno do trade</th>
                                </tr>
                                <tr>
                                    <th className="text-end border-start">%</th>
                                    <th className="pe-3"></th>
                                </tr>
                            </thead>
                            <tbody>
                                {series.map(d => (
                                    <tr key={d.date}>
                                        <td className="ps-3 text-nowrap">{d.date.slice(8)}/{d.date.slice(5, 7)}</td>
                                        <td className="text-center text-muted">{d.trades != null ? d.trades : '—'}</td>
                                        <td className={`text-end fw-bold ${cls(d.realized)}`}>{fmt(d.realized)}</td>
                                        <td className={`text-end border-start ${cls(d.pct)}`}>{fmt(d.pct)}%</td>
                                        <td className="pe-3" title="Barra proporcional ao retorno (%) do dia">
                                            <div style={{
                                                height: 8, borderRadius: 4,
                                                width: `${Math.max(3, Math.abs(d.pct) / maxAbsPct * 100)}%`,
                                                background: d.pct >= 0 ? '#28a745' : '#dc3545'
                                            }} />
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>
        </div>
    );
}

export default DailyRealizedCard;
